import React from 'react'
import TableContainer from '../../component/TableContainer'
import NotificationCenter from '../../component/NotificationCenter'
import Header from '../../component/Header'
import Menu from '../../component/Menu'
import Setting from '../../component/Settings'
// import "./dashboard.css" .....

const Settings = () => {
    return (
        <>
            <Menu logic={<Setting/>} page={"Settings"} />
            {/* "Customize your experience with AICS to optimize the customer experience for your customers." */}
        </>
    )
}

export default Settings